import React from 'react'
import logUtil from 'utils/log'
import getIdCustomerUtil from 'utils/customer/get-id'
import useSelector from 'hooks/use-selector'
import './index.css'
import getSurveyStatsByMemberIdSquadSelector from 'modules/squad/redux/selectors/get-survey-stats-by-member-id'
import Section from 'components/Section'
import H3 from 'components/H3'
import pluralizeStringUtil from 'utils/string/plurialize'
import Link from 'components/Link'
import { ROUTE_PATH } from 'modules/route/constants'
import logEventAnalyticsUtil from 'utils/analytics/log-event'

const RATE_MORE_SAMPLES = 'Rate more samples'

const ANALYTICS_EVENT = {
  SQUAD_RATE_MORE_SAMPLES: 'SQUAD_RATE_MORE_SAMPLES'
}
export default function SquadPageYouVeRatedSamplesAcrossOrdersContent () {
  const customerId = getIdCustomerUtil()
  /**
   * @type {import('modules/squad/types').SurveyStats}
   */
  const surveyStats = useSelector(getSurveyStatsByMemberIdSquadSelector(customerId))
  const debugProps = {
    surveyStats
  }

  logUtil('SquadPageYouVeRatedSamplesAcrossOrdersContent').debug('debugProps=', debugProps)

  const answersCount = surveyStats.survey_answer_count
  const surveyCount = surveyStats.survey_count

  const handleClickRateMoreSamples = () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.SQUAD_RATE_MORE_SAMPLES)
  }
  const icon = (
    <svg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M8.00006 16.4582C7.84006 16.4582 7.68004 16.3973 7.55837 16.2748C7.3142 16.0307 7.3142 15.6348 7.55837 15.3906L12.95 9.999L7.55837 4.60736C7.3142 4.36319 7.3142 3.96733 7.55837 3.72316C7.80254 3.479 8.1984 3.479 8.44257 3.72316L14.2759 9.5565C14.5201 9.80066 14.5201 10.1965 14.2759 10.4407L8.44257 16.274C8.32007 16.3974 8.16006 16.4582 8.00006 16.4582Z' fill='#E15EC4' />
    </svg>
  )
  return (
    <Section className='squad-page-you-ve-rated-samples-across-orders-content'>
      <H3>You’ve rated {answersCount} {pluralizeStringUtil('sample', answersCount)} <br />across {surveyCount} {pluralizeStringUtil('order', answersCount)}.</H3>

      <Link onClick={handleClickRateMoreSamples} href={ROUTE_PATH.PS_SURVEY}>
        {RATE_MORE_SAMPLES}
        {icon}
      </Link>
    </Section>
  )
}
